// use for reuse strategy routing ... 
// record list at the moment
export enum ReuseStrategyEnum {
    REUSED,
    RESET
}